module.exports = {
  __depends__: [
    require(139),
    require(112)
  ],
  __init__: [ 'attachSupport'],
  attachSupport: [ 'type', require(90) ]
};
